export const STEP_PERSON = [
    {
        step: 1,
        name: 'Tu perfil',
    },
    {
        step: 2,
        name: 'Tus datos',
    },
];
